import { useNavigate } from "react-router";

import { Box } from "@design-system/Box/Box";
import { Card } from "@design-system/Card/Card";
import { Text } from "@design-system/Text/Text";
import { TileButton } from "@design-system/TileButton/TileButton";

import { routes } from "@pages/routes";

import classes from "./GettingStartedCard.module.css";

export const GettingStartedCard = () => {
  const navigate = useNavigate();

  const handleCreateClientManuallyClick = () => {
    navigate(routes.portal.gettingStarted.createClientManually.$path(), {
      viewTransition: true,
    });
  };

  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Let's set up your first client</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <Box direction="column" gap={16} stretch>
          <Box direction="column" gap={16}>
            <Text size={16} color="textSecondary">
              To get started, you need to connect your existing client list or
              create your first client manually.
            </Text>
          </Box>
          <div className={classes.grid}>
            <TileButton
              title="Microsoft partner integration"
              description="Connect your existing client list using the Microsoft partner integration"
              icon="faPlug"
            />
            <TileButton
              title="Create client manually"
              description="Create your first client manually"
              icon="faPenToSquare"
              onClick={handleCreateClientManuallyClick}
            />
          </div>
        </Box>
      </Card.Body>
    </Card>
  );
};
